import {
  Box,
  Card,
  CardHeader,
  Chip,
  Theme,
  Typography,
  createStyles,
  makeStyles,
  useSnackbar,
} from '@forgeglobal/design-framework'
import { FileUploaderCard } from 'components/shared/FileUploaderCard'
import {
  OfferingFileFragment,
  useGetOfferingFilesQuery,
  useUploadOfferingParticipantsMutation,
} from 'graphql/bindings/AdminBindings'
import { download } from 'util/DocumentUtils'
import React from 'react'
import moment from 'moment'

interface CampaignParticipantsProps {
  offeringId: string
}

const useStyles = makeStyles(({ spacing }: Theme) =>
  createStyles({
    title: {
      display: 'flex',
      justifyContent: 'space-between',
      cursor: 'pointer',
    },
    uploadButton: {
      marginTop: spacing(2),
    },
  })
)

export const CampaignParticipants: React.FC<CampaignParticipantsProps> = ({ offeringId }) => {
  const { enqueueSnackbar } = useSnackbar()
  const classes = useStyles()
  const [uploadCSVs] = useUploadOfferingParticipantsMutation()

  const { data } = useGetOfferingFilesQuery({
    variables: {
      offeringId,
    },
  })

  const participantFiles = data?.offering.files.filter(file => {
    return file.tags?.some(tag => tag.tag === 'csv-upload')
  })

  const handleFileSerials = (fileSerials: string[]) => {
    return uploadCSVs({
      variables: {
        fileSerials,
        offeringId,
      },
    })
  }

  const handleClick = (file: OfferingFileFragment) => {
    enqueueSnackbar(`Downloading document ${file.filename} ...`)
    download(file)
  }

  const numParticipants = data?.offering.num_participants ?? 0

  return (
    <FileUploaderCard
      acceptedFileTypes=".csv"
      rightTitle={`${numParticipants} participants added`}
      title={
        <Typography variant="h6" color="secondary">
          Participants
        </Typography>
      }
      uploadCaption="Add Participants"
      isPaperclipVisible
      onFileSerials={handleFileSerials}>
      {participantFiles?.map(file => {
        const { id, filename, date_created } = file
        return (
          <Box mb={2} key={id}>
            <Card>
              <CardHeader
                secondaryIcon={<Chip label="Uploaded" color="secondary" />}
                title={
                  <div className={classes.title} onClick={() => handleClick(file)}>
                    <Typography variant="subtitle2">{filename}</Typography>
                    <Typography variant="subtitle2">{moment(date_created).format('ddd, l [at] LT')}</Typography>
                  </div>
                }
              />
            </Card>
          </Box>
        )
      })}
    </FileUploaderCard>
  )
}
